import { Text } from "@chakra-ui/react";

/**
 * Eyebrow heading for the Browse page sections ("COMMUNITY READING ORDERS",
 * "POPULAR READING ORDERS", ...). One style for the discovery rows and the
 * category grids below them.
 */
const BrowseSectionTitle = ({ children, ...props }) => (
  <Text
    color="gray.400"
    fontSize="sm"
    mt="6"
    mb="2"
    textTransform="uppercase"
    {...props}
  >
    {children}
  </Text>
);

export default BrowseSectionTitle;
